import React, { useMemo } from 'react'
import { Radio } from '@mds/mds-reactjs-library'
import { buildCurrencyOptions, parseCurrencySelectionToCode } from './liveDashboardCurrency'

const LiveDashboardCurrencyFilter = ({
  dimension,
  selection,
  setSelection,
  setValidationMessage,
}) => {
  const options = useMemo(() => buildCurrencyOptions(dimension), [dimension])

  const selectedCode = useMemo(
    () => parseCurrencySelectionToCode(selection?.Attributes, dimension),
    [selection?.Attributes, dimension],
  )

  const applySelection = (option) => {
    setSelection(dimension.DimensionID, [option.attributeId])
    setValidationMessage?.('')
  }

  return (
    <>
      {options.map((option) => (
        <div key={option.code} className="popup-item">
          <div className="flex vbn-radio-leaf-row--vehicles-total">
            <div className="spacer" />
            <div
              className="info"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  applySelection(option)
                }
              }}
              onClick={() => applySelection(option)}
            >
              <p className="attribute-name">{option.label}</p>
            </div>
            <div className="tree-selector-cell">
              <Radio
                value={option.code}
                checked={selectedCode === option.code}
                label=""
                onClick={() => applySelection(option)}
              />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

export default LiveDashboardCurrencyFilter
